<template>
<div class="chapter">
<div class="inner_page">
<h1>Table of Contents</h1>
<p><span href="#/c001" title="Link target outside of Sample">Title Page</span></p>
<p><span href="#/c002" title="Link target outside of Sample">Copyright Page</span></p>
<p><a href="#/c003">Fallen Royals (Bad Boy Royals of Kingsbury Prep)</a></p>
<p><a href="#/c004">PLEASE READ BEFORE READING THIS BOOK</a></p>
<p><span href="#/c005" title="Link target outside of Sample">Get a Free Copy of Kailin Gow’s Full Book | Blue Room Vol.1 | When you Sign Up for Rachel Angel and Kailin Gow’s  New Releases Newsletter!</span></p>
<p><span href="#/c006" title="Link target outside of Sample">Heartbreak Falls Series</span></p>
<p><span href="#/c007" title="Link target outside of Sample">Excerpt | DIAMONDS AND DRAGONS | Now Available</span></p>
<p><span href="#/c008" title="Link target outside of Sample">Want to read more? | Diamonds and Dragons is Now Available on KU</span></p>
<p><span href="#/c009" title="Link target outside of Sample">Diamonds and Dragons</span></p>
<p><span href="#/c010" title="Link target outside of Sample">Roses and Emeralds</span></p>
<p><span href="#/c011" title="Link target outside of Sample">Silver and Starlight</span></p>
<p><span href="#/c012" title="Link target outside of Sample">OTHER REVERSE HAREM or RH BULLY ROMANCE BOOKS NOW AVAILABLE OR FOR PRE-ORDER | FALLEN FAE ACADEMY | Series Blurb</span></p>
<p><span href="#/c013" title="Link target outside of Sample">Initiation:  Year 1</span></p>
<p><span href="#/c014" title="Link target outside of Sample">Transformation:  Year 2</span></p>
<p><span href="#/c015" title="Link target outside of Sample">Declaration: Year 3</span></p>
<p><span href="#/c016" title="Link target outside of Sample">The Shadowlight Academy Series | The Beautiful Boys</span></p>
<p><span href="#/c017" title="Link target outside of Sample">Magic Over Boys</span></p>
<p><span href="#/c018" title="Link target outside of Sample">Gone Rogue</span></p>
<p><span href="#/c019" title="Link target outside of Sample">The Shadowlight Hunters Academy Series</span></p>
<p><span href="#/c020" title="Link target outside of Sample">SOCIETY OF SUPERNATURAL SLEUTHS</span></p>
<p><span href="#/c021" title="Link target outside of Sample">SCARLET’S THREE</span></p>
<p><span href="#/c022" title="Link target outside of Sample">IMMORTAL MAGIC</span></p>
<p><span href="#/c023" title="Link target outside of Sample">FAE AND FANGS</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?2244be53